<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-microsoft-windows</v-icon>{{$t('profile.operatingsystem.operatingsystems')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <OperatingSystemForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import OperatingSystemForm from '../../components/operatingsystem/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'OperatingSystem';

const { mapFields } = createHelpers({
  getterType: 'operatingsystem/getField',
  mutationType: 'operatingsystem/updateField'
});

export default {
  name: 'OperatingSystemCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    OperatingSystemForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('operatingsystem', ['create', 'reset'])
  }
};
</script>
